<template>
  <div class="rc">
    <div class="rc-top">
      <strong>From the NPI Registry</strong>
      <span class="rc-chip">NPI {{ result.npi }}</span>
    </div>
    <div class="rc-grid">
      <span class="rc-k">Name</span><span>{{ result.name }}</span>
      <span class="rc-k">Specialty</span><span>{{ result.specialty || '—' }}</span>
      <span class="rc-k">Practice locations</span>
      <span class="rc-locs">
        <span v-for="(l, i) in locations" :key="i">{{ [l.name, [l.city, l.state].filter(Boolean).join(', ')].filter(Boolean).join(' · ') }}</span>
        <span v-if="!locations.length">—</span>
      </span>
    </div>
    <div class="rc-note">
      <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2169A8" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></svg>
      <span><slot /></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegistryCard',
  props: { result: { type: Object, required: true } },
  computed: {
    locations() {
      return this.result.locations || []
    }
  }
}
</script>

<style scoped>
.rc { background: #f7f4ec; border-radius: 10px; padding: 16px; display: flex; flex-direction: column; gap: 10px; }
.rc-top { display: flex; justify-content: space-between; align-items: center; gap: 8px; flex-wrap: wrap; font-size: 14px; }
.rc-chip { font-size: 12px; font-weight: 600; background: #daeefa; color: #154b7a; padding: 3px 10px; border-radius: 999px; }
.rc-grid { display: grid; grid-template-columns: 140px 1fr; gap: 6px 12px; font-size: 14px; }
.rc-k { color: #4a5568; }
.rc-locs { display: flex; flex-direction: column; gap: 2px; }
.rc-note { display: flex; gap: 8px; align-items: flex-start; font-size: 13px; color: #33465e; background: #fff; border-radius: 8px; padding: 10px 12px; }
.rc-note svg { flex: 0 0 auto; margin-top: 1px; }
</style>
